import Image from "next/image";
import type { ComparisonSlug } from "@/lib/comparison-links";

const marks: Record<ComparisonSlug, string> = {
  "cooperly-vs-windmill": "/compare/windmill.png",
  "cooperly-vs-steady": "/compare/steady.png",
  "cooperly-vs-fellow": "/compare/fellow.png",
  "cooperly-vs-range": "/compare/range.png",
  "cooperly-vs-geekbot": "/compare/geekbot.png",
  "cooperly-vs-peoplebox": "/compare/peoplebox.png",
  "cooperly-vs-lattice": "/compare/lattice.png",
  "cooperly-vs-workleap": "/compare/workleap.png",
  "cooperly-vs-officevibe": "/compare/officevibe.png",
};

export function ComparisonBrandIcon({ slug }: { slug: ComparisonSlug }) {
  const mark = marks[slug];
  return mark.startsWith("/") ? (
    <Image
      src={mark}
      alt=""
      aria-hidden
      width={32}
      height={32}
      className="size-8 object-contain"
    />
  ) : (
    <span
      aria-hidden
      className="text-base font-semibold tracking-tight text-foreground"
    >
      {mark}
    </span>
  );
}
